module.exports = __webpack_public_path__ + "static/media/brochure_2021_OI.3e1327f8.pdf";